import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ChatSection from '../components/ChatSection'
import LoadIcon from '../components/LoadIcon'
import PageWithBg from '../components/PageWithBg'
import config from '../config'
import { ChatDb, HallOneDb } from '../firebaseConfig'
import { SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'
import { useAutoMute } from '../utils/useAutoMute'

const Page = styled.div`
  overflow: hidden;
  .content {
    ${config.layout.auditoriumVid}
    position: absolute;
    background: black;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
  .chat {
    max-width: 350px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 67%;
    bottom: 0;
    right: 5%;
    z-index: 30;
  }
`

export default function AuditoriumPage({ liveUrl, hallNumber, currentUser }) {
  useAutoMute()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    document.title = `${config.eventName} | Conference`
  }, [])

  useEffect(() => {
    Amplitude.visit(`Lecture Hall ${hallNumber}`)
    Amplitude.visitTemp(`Lecture Hall ${hallNumber}`)
  }, [currentUser.id, hallNumber])

  return (
    <>
      {loading && <LoadIcon />}
      <Page>
        <PageWithBg bgImg={config.assets.auditorium1.landscape}>
          <div className="content">
            <iframe
              title="Live Broadcast"
              src={`${liveUrl}?autoplay=1`}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setLoading(false)
              }}
            />
          </div>
          {/* <div className="chat h-100">
            <ChatSection firebaseDb={HallOneDb} chatDb={ChatDb} />
          </div> */}
        </PageWithBg>
      </Page>
    </>
  )
}
